import { useEffect, useState } from "react";

// IMPORT SOUND
import successSound from "../../assets/sounds/success.mp3";
import errorSound from "../../assets/sounds/error.mp3";

const Toast = ({ message, type, onClose, index = 0 }) => {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    // 🔊 PLAY SOUND
    const playSound = () => {
      let audio;

      if (type === "success") {
        audio = new Audio(successSound);
      } else if (type === "error" || type === "delete") {
        audio = new Audio(errorSound);
      }

      if (audio) {
        audio.volume = 0.4; // keep it soft
        audio.play().catch(() => {}); // avoid browser block error
      }
    };

    playSound();

    // PROGRESS TIMER
    const duration = 3000;
    const intervalTime = 30;
    const step = 100 / (duration / intervalTime);

    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev <= 0) {
          clearInterval(interval);
          onClose();
          return 0;
        }
        return prev - step;
      });
    }, intervalTime);

    return () => clearInterval(interval);
  }, [onClose, type]);

  const styles = {
    success: { border: "#067d62", iconBg: "#e6f4f1", icon: "✔" },
    error: { border: "#b12704", iconBg: "#fdecea", icon: "✖" },
    delete: { border: "#d97706", iconBg: "#fff4e5", icon: "⚠" },
  };

  const s = styles[type] || styles.success;

  return (
    <div
      style={{
        position: "fixed",
        bottom: `${24 + index * 70}px`,
        right: "24px",
        zIndex: 9999,
        width: "320px",
        background: "#fff",
        border: "1px solid #e5e7eb",
        borderLeft: `4px solid ${s.border}`,
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        overflow: "hidden",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "12px", padding: "14px 16px" }}>
        <div
          style={{
            width: "26px",
            height: "26px",
            borderRadius: "6px",
            background: s.iconBg,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "13px",
            fontWeight: "bold",
            color: s.border,
          }}
        >
          {s.icon}
        </div>

        <div style={{ flex: 1, fontSize: "14px", color: "#111827" }}>
          {message}
        </div>

        <button
          onClick={onClose}
          style={{
            border: "none",
            background: "transparent",
            cursor: "pointer",
            fontSize: "16px",
            color: "#6b7280",
          }}
        >
          ✕
        </button>
      </div>

      {/* Progress */}
      <div style={{ height: "3px", background: "#f3f4f6" }}>
        <div
          style={{
            height: "100%",
            width: `${progress}%`,
            background: s.border,
            transition: "width 0.03s linear",
          }}
        />
      </div>
    </div>
  );
};

export default Toast;